"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PromptSuggestionCardContainer = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PromptSuggestionCard = require("./PromptSuggestionCard");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PromptSuggestionCardContainer = ({
  promptSuggestionList = [],
  setSearchBoxInput
}) => {
  const [isSelected, setIsSelected] = (0, _react.useState)(promptSuggestionList.map(() => false));
  const updateSelection = (key, selectedText) => {
    setIsSelected(isSelected.map((item, index) => index === key));
    setSearchBoxInput(selectedText);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "prompt-suggestion-card-container",
    "data-testid": "prompt-suggestion-card-container",
    className: "prompt-suggestion-card-container d-flex align-items-start align-self-stretch"
  }, promptSuggestionList.map((suggestion, index) => /*#__PURE__*/_react.default.createElement(_PromptSuggestionCard.PromptSuggestionCard, {
    key: index,
    listId: index,
    promptSuggestion: suggestion,
    isSelected: isSelected[index],
    updateSelection: updateSelection
  })));
};
exports.PromptSuggestionCardContainer = PromptSuggestionCardContainer;
PromptSuggestionCardContainer.propTypes = {
  promptSuggestionList: _propTypes.default.arrayOf(_propTypes.default.string),
  setSearchBoxInput: _propTypes.default.func
};